import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=dd19efb0&scoped=true&"
import script from "./CustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerDetail.vue?vue&type=style&index=1&id=dd19efb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd19efb0",
  null
  
)

export default component.exports